<!--
 * @Author: zhangcx33595
 * @Date: 2021-08-03 13:40:14
 * @LastEditors: zhangcx33595
 * @LastEditTime: 2021-11-13 20:23:05
 * @FilePath: \openplat-web\src\gtn\views\frontViews\workOrder.vue
-->
<!--  -->
<template>
  <div class="submitWorkOrder-wrapper">
    <div class="submitWorkOrder-bg">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {

  }
}
</script>
<style lang="scss" scoped>
.submitWorkOrder-bg {
  background: url('~@/assets/submitWorkOrder/banner-1920.png') top center no-repeat;
  background-size: 100%;
}
</style>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/workOrder.vue